import { useEffect, useState } from "react";
import Dropdown from "../../../components/form/Dropdown";
import TextField from "../../../components/form/TextField";
import { useGetVideosQuery } from "../../../features/videos/videosAPI";
import {
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useGetAssignmentsQuery,
} from "../../../features/assignments/assignmentsAPI";
import { useNavigate } from "react-router";
import ErrorMessage from "../../ui/ErrorMessage";
function AssignmentForm({ initialData }) {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({});
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [filteredVideoList, setFilteredVideoList] = useState(false);

  const {
    data: videos,
    isLoading: isVideosLoading,
    isError: isVideosError,
  } = useGetVideosQuery();

  const [addAssignment, { isLoading, isError, isSuccess }] =
    useAddAssignmentMutation();
  const [
    editAssignment,
    {
      isLoading: isEditLoading,
      isError: isEditError,
      isSuccess: isEditSuccess,
    },
  ] = useEditAssignmentMutation();

  const { data: assignments, isLoading: assignmentsLoading } =
    useGetAssignmentsQuery();

  useEffect(() => {
    if (assignments?.length > 0 && videos?.length > 0) {
      const currentlyAssignedVideoIDs = assignments?.map(
        (assignmet) => assignmet?.video_id
      );
      const filteredList = videos?.filter(
        (video) => !currentlyAssignedVideoIDs?.includes(video.id)
      );
      let currentlyAssignedVideo = null;
      if (initialData?.video_id) {
        currentlyAssignedVideo = videos?.find(
          (video) => video.id === initialData.video_id
        );
      }
      if (currentlyAssignedVideo) {
        setFilteredVideoList([currentlyAssignedVideo, ...filteredList]);
      } else {
        setFilteredVideoList(filteredList);
      }
    }
  }, [assignments, videos, initialData]);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const video_id = Number(formValues.video);

    const video_title = videos?.find((video) => video.id === video_id)?.title;
    delete formValues.video;

    const payload = {
      ...formValues,
      video_id: video_id,
      video_title: video_title,
    };

    if (initialData?.id) {
      editAssignment({ id: initialData.id, data: payload });
    } else {
      addAssignment(payload);
    }
  }

  useEffect(() => {
    if (isSuccess || isEditSuccess) {
      navigate("/admin/assignment");
    }
    if (isError || isEditError) {
      setShowErrorMessage(true);
    }
  }, [isSuccess, isError, isEditSuccess, isEditError, navigate]);

  useEffect(() => {
    setFormValues({ ...initialData, video: initialData.video_id });
  }, [initialData, videos]);

  let form = null;
  if (isVideosLoading || assignmentsLoading) form = "Loading...";
  else if (isVideosError) form = "Something went wrong!";
  else
    form = (
      <form className="space-y-6" onSubmit={handleSubmit}>
        <TextField
          id="title"
          label="Title"
          type="text"
          onChange={handleChange}
          value={formValues.title}
        />
        <Dropdown
          id="video"
          label="Video"
          options={filteredVideoList}
          labelID="title"
          value={formValues.video}
          onChange={handleChange}
          required
        />
        <TextField
          id="totalMark"
          label="Total Mark"
          onChange={handleChange}
          value={formValues.totalMark}
          type="number"
        />

        {showErrorMessage && <ErrorMessage />}

        <div
          style={{
            display: "grid",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            type="submit"
            className="btn btn-primary"
            style={{
              padding: "0.5rem 2rem",
              marginTop: "0.5rem",
              width: "fit-content",
            }}
            disabled={isLoading || isEditLoading}
          >
            {initialData?.id ? "Edit" : "Add"}
          </button>
        </div>
      </form>
    );

  return form;
}

export default AssignmentForm;
